import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../_actions/dataActions";
import * as userActions from "../../../_actions/userActions";
import Section from "../../UI/Section";
import Basic from "./Basic";
import Location from "./Location";
import Professional from "./Professional";
import getMyPartnerPreference from "../../../_selectors/userSelectors/getMyPartnerPreference";
import getMyPartnerPreferenceRaw from "../../../_selectors/userSelectors/getMyPartnerPreferenceRaw";
import Wrapper from "../../../_hoc/Wrapper";

class PartnerPreference extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      preference,
      getPartnerPreference
    } = this.props;
    updateHeader({
      title: "Partner Preference",
      description: "Tell us what you look for in your special one"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Profile", link: "/profile" },
      { label: "Partner Preference", link: "/profile/partner-preference" }
    ]);

    this.unsubscribe = getPartnerPreference();
  }
  componentWillUnmount() {
    try {
      this.unsubscribe();
    } catch (error) {
      //do nothing
    }
  }
  _updatePreference = payload => {
    const { updatePartnerPreference, preferenceRaw } = this.props;
    updatePartnerPreference({
      ...payload,
      ...{ previous: preferenceRaw }
    });
  };
  render() {
    const { preference } = this.props;
    return (
      <Wrapper>
        <Section white>
          <Basic preference={preference} update={this._updatePreference} />
        </Section>
        <Section>
          <Location update={this._updatePreference} />
        </Section>
        <Section white>
          <Professional
            preference={preference}
            update={this._updatePreference}
          />
        </Section>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  preference: getMyPartnerPreference(state),
  preferenceRaw: getMyPartnerPreferenceRaw(state)
});
const mapDispatchToProps = dispatch => ({
  getPartnerPreference: () => dispatch(userActions.getPartnerPreference()),
  updatePartnerPreference: payload =>
    dispatch(userActions.updatePartnerPreference(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerPreference);



// WEBPACK FOOTER //
// ./src/_components/Profile/PartnerPreference/index.js